import { host } from '@/config';
import { Category } from '@/types/article';

export type CategoryLabelVariant = 'primary' | 'secondary';

interface CategoryLabelProps {
  category: Category;
  className?: string;
  variant?: CategoryLabelVariant;
}

const variantClasses: Record<CategoryLabelVariant, string> = {
  primary: 'bg-primary text-neutral',
  secondary: 'bg-[#59214D] text-neutral',
};

export const CategoryLabel: React.FC<CategoryLabelProps> = ({ category, className, variant = 'primary' }) => {
  return (
    <a
      data-testid="article-category-link"
      href={`${host}${category.data.url}`}
      className={`${variantClasses[variant]} inline-block rounded-full px-8 py-3 text-center text-[14px] font-bold ${className}`}
    >
      {category.data.title}
    </a>
  );
};
